package ru.villawonka.app.presentation.design.extensions

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.outlinePrimary

@Composable
fun RowScope.AppSeparator(
    width: Dp = 1.dp,
    horizontalPadding: Dp
) {
    Box(
        modifier = Modifier
            .padding(horizontal = horizontalPadding)
            .background(color = MaterialTheme.colors.outlinePrimary)
            .width(width)
            .fillMaxHeight()
    )
}
@Composable
fun ColumnScope.AppSeparator(
    height: Dp = 1.dp,
    verticalPadding: Dp = 0.dp
) {
    Box(
        modifier = Modifier
            .padding(vertical = verticalPadding)
            .background(color = MaterialTheme.colors.outlinePrimary)
            .height(height)
            .fillMaxWidth()
    )
}